module.exports = __webpack_public_path__ + "img/AC_S4_Final_Piloti_Top10.9b0a4d8c.png";